$(document).ready(function () {
    $(".buyBoxSecond__buyOptions .buyBoxSecond__buyCta").click(function(e){
      e.preventDefault();
      let variant_id;
      let sku;
      let subsType;
      $(".buyBoxSecond__buyOptions .buyBoxSecond__rechargeInput").each(function(){
        if($(this).is(":checked")){
          variant_id = $(this).attr("product-id");
          sku = $(this).attr("product-sku");
          subsType =  $(this).attr("subs-type");
        }
      });
      console.log(variant_id);
      console.log(sku);
      if(subsType == 'autorenew'){
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
              quantity: 1,
              id: variant_id,
              selling_plan: $(this).attr("product-selling-plan")
          },
          dataType: "json",
          success: function(data) {
              console.log(data.id);
              
          },
        });
      }else if(subsType == 'onetime'){
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            quantity: 1,
            id: variant_id
          },
          dataType: "json",
          success: function (data) {
            console.log(data.id);
            
          }
        });
      }
    });

    $(".buyBoxSecond__buyOptions .buyBoxSecond__rechargeInput").click(function() {
      $(this).each(function() {
          $(".buyBoxSecond__buyOptions .buyBoxSecond__rechargeOption").removeClass("is--active");
          if ($(this).is(":checked")) {
              $(this).parents(".buyBoxSecond__rechargeOption").addClass("is--active");
          }
      });
    });  
});